/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Why_Testimonial_3_QuoteInputs */

const es_home_why_testimonial_3_quote = /** @type {(inputs: Home_Why_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implementación en minutos, no meses. Conectores nativos sin configuración compleja. Control total de permisos.`)
};

const en_home_why_testimonial_3_quote = /** @type {(inputs: Home_Why_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implementation in minutes, not months. Native connectors without complex configuration. Total permission control.`)
};

/**
* | output |
* | --- |
* | "Implementation in minutes, not months. Native connectors without complex configuration. Total permission control." |
*
* @param {Home_Why_Testimonial_3_QuoteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_why_testimonial_3_quote = /** @type {((inputs?: Home_Why_Testimonial_3_QuoteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Why_Testimonial_3_QuoteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_why_testimonial_3_quote(inputs)
	return en_home_why_testimonial_3_quote(inputs)
});
export { home_why_testimonial_3_quote as "home.why.testimonial_3_quote" }